import * as React from 'react';
import { SVGProps } from 'react';

const IconDebugSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.001 2.05C5.947 2.55 2 6.813 2 12c0 2.4.846 4.604 2.256 6.327l1.423-1.423a8.001 8.001 0 0 1 5.322-12.842V2.049ZM18.322 16.904a8.001 8.001 0 0 0-5.32-12.842V2.05C18.053 2.552 22 6.815 22 12c0 2.4-.846 4.603-2.255 6.327l-1.424-1.423ZM12 20a7.965 7.965 0 0 1-4.907-1.681L5.67 19.742A9.959 9.959 0 0 0 12 22a9.959 9.959 0 0 0 6.33-2.259l-1.422-1.423A7.965 7.965 0 0 1 12 20Z" />
    <path d="m9.5 16 7-4-7-4v8Z" />
  </svg>
);
export default IconDebugSizeM;
